import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerCurrency } from './total-per-currency.model';

export const ALL_YEARS: number = -1;
export const TOTAL_PER_YEAR_FILTER_SCHEMA = Object.freeze({
  YEAR: ALL_YEARS, // tax year
  TOTALS: List<TotalPerCurrency>([]),
});
const RECORD = generateSchema(TOTAL_PER_YEAR_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_YEAR_FILTER_SCHEMA);

export class TotalPerYearFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOTALS,
        value: props.get(KEYS.TOTALS)
          ? this.totals.map((params) => new TotalPerCurrency(params))
          : List<TotalPerCurrency>([]),
      },
    ]);

    return selfModel as TotalPerYearFilter;
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }

  get totals(): List<TotalPerCurrency> {
    return this.get(KEYS.TOTALS);
  }

  isAllYears(): boolean {
    return this.year === ALL_YEARS;
  }
}
